import { BATTLESHIP } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import UIButton from 'UIComponents/button/UIButton';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import styled from 'styled-components';
import { TRIAL_UPGRADE_NAV_BANNER } from '../../../constants/ErrorBoundaryNames';
import { withErrorBoundary } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIFlex = styled(UIFlex).withConfig({
  displayName: "TrialUpgradeNavBanner__StyledUIFlex",
  componentId: "sc-1f1jfq-0"
})(["min-width:100%;max-width:100%;height:56px;border-bottom:2px solid ", ";"], BATTLESHIP);
const TrialUpgradeNavBanner = ({
  apiName
}) => {
  const upgradeProduct = ApiNameToUpgradeProductMap[apiName];
  return /*#__PURE__*/_jsxs(StyledUIFlex, {
    align: "center",
    justify: "end",
    direction: "row",
    wrap: "wrap",
    children: [/*#__PURE__*/_jsxs(UIButton
    //add tracking
    , {
      use: "transparent",
      href: `/trial-guide/${PortalIdParser.get()}/${upgradeProduct}`,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "viewDetails"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "interstitial.hc0119.links.trialGuide"
      })]
    }), /*#__PURE__*/_jsxs(UICopyButton, {
      use: "transparent",
      className: "p-right-8",
      tooltipPlacement: "bottom",
      hintSuccess: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.productPages.linkCopied"
      }),
      value: window.location.href,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "forward"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "interstitial.hc0119.links.share"
      })]
    })]
  });
};
export default withErrorBoundary(TrialUpgradeNavBanner, {
  boundaryName: TRIAL_UPGRADE_NAV_BANNER
});